var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c(
          "fragment",
          [
            _c("skp-breadcrumbs", {
              on: {
                "page-title": function(val) {
                  return (_vm.pageTitle = val)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "srchTop_wrap srchFaq_wrap" }, [
          _c("article", { staticClass: "srch_basic" }, [
            "C550" === _vm.corpCd || "WA" === _vm.corpCd
              ? _c("dl", { staticClass: "dl_search set_2" }, [
                  _c(
                    "dd",
                    {
                      staticClass: "clearable",
                      attrs: { "data-input-type": "input" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchTitle,
                            expression: "searchTitle"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t(
                            "FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH"
                          )
                        },
                        domProps: { value: _vm.searchTitle },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.search(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchTitle = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticClass: "clearable",
                      attrs: { "data-input-type": "input" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchKeyword,
                            expression: "searchKeyword"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("FIELD.GLOBAL.SEARCHKEYWORD")
                        },
                        domProps: { value: _vm.searchKeyword },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.search(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchKeyword = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("dd", { staticClass: "btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_srch",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.search(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                    )
                  ])
                ])
              : _c("dl", { staticClass: "dl_search" }, [
                  _c(
                    "dd",
                    {
                      staticClass: "clearable",
                      attrs: { "data-input-type": "input" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchTitle,
                            expression: "searchTitle"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: { type: "text", placeholder: "Enter keyword" },
                        domProps: { value: _vm.searchTitle },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.search(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchTitle = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("dd", { staticClass: "btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_srch",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.search(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                    )
                  ])
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "top_mobile" }, [
              _c("div", { staticClass: "mobile_title" }, [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "dl_select" }, [
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.category1Code,
                          expression: "category1Code"
                        }
                      ],
                      staticClass: "slt_white w100p",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.category1Code = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.categoryList(2)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.category1CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.pageName + item.code,
                            domProps: { value: item.code }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(item.codeName) +
                                "\n                                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "dl_select" }, [
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.category2Code,
                          expression: "category2Code"
                        }
                      ],
                      staticClass: "slt_white w100p",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.category2Code = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.category2CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.pageName + item.code,
                            domProps: { value: item.code }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(item.codeName) +
                                "\n                                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "srch_detail" }, [
            _c("div", { staticClass: "list_wrap" }, [
              _c("header", [
                _c("h3", [_vm._v(_vm._s(_vm.$t("FIELD.FAQ.CATEGORY.QUICK")))])
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "ul_list" },
                _vm._l(_vm.supportSnb.faqQuickCategoryList, function(item) {
                  return _c(
                    "li",
                    {
                      key:
                        _vm.pageName +
                        item.WORK_KEY_1 +
                        item.WORK_KEY_2 +
                        "quick"
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.getQuickCategoryClick(
                                item.WORK_KEY_1,
                                item.WORK_KEY_2
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.getQuickName(
                                  item.WORK_KEY_1_NM,
                                  item.WORK_KEY_2_NM,
                                  item.WORK_KEY_3_NM
                                )
                              ) +
                              "\n                            "
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inquiry_wrap" }, [
          _c(
            "ul",
            { staticClass: "ul_list list_03" },
            _vm._l(_vm.supportSnb.faqInquiry, function(item, idx) {
              return _c(
                "li",
                {
                  key: _vm.pageName + item.INQUIRY_TYPE1 + idx + "mobile",
                  class: _vm.getSnbClass(item.INQUIRY_TYPE1)
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.snbClick(
                            $event,
                            item.INQUIRY_TYPE1,
                            "",
                            ""
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.INQUIRY_TYPE_NM1)
                      ),
                      item.TOTAL_CNT
                        ? _c("em", [_vm._v("(" + _vm._s(item.TOTAL_CNT) + ")")])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  !(
                    "ALL" === item.INQUIRY_TYPE1 || "ETC" === item.INQUIRY_TYPE1
                  )
                    ? _c(
                        "a",
                        {
                          staticClass: "ico_arrow",
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.snbClick(
                                $event,
                                item.INQUIRY_TYPE1,
                                "",
                                "arrow"
                              )
                            }
                          }
                        },
                        [_c("span", { staticClass: "sr_only" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !(
                    "ALL" === item.INQUIRY_TYPE1 || "ETC" === item.INQUIRY_TYPE1
                  )
                    ? _c(
                        "ul",
                        _vm._l(item.faqSubInquiry, function(itemSub, idxSub) {
                          return _c(
                            "li",
                            {
                              key:
                                _vm.pageName +
                                itemSub.INQUIRY_TYPE1 +
                                idxSub +
                                "mobile",
                              on: {
                                click: function($event) {
                                  return _vm.snbClick(
                                    $event,
                                    item.INQUIRY_TYPE1,
                                    itemSub.INQUIRY_TYPE2,
                                    ""
                                  )
                                }
                              }
                            },
                            [
                              _c("a", { attrs: { href: "javascript:" } }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(itemSub.INQUIRY_TYPE_NM2) +
                                    "\n                                "
                                ),
                                itemSub.TOTAL_CNT
                                  ? _c("em", [
                                      _vm._v(
                                        "(" + _vm._s(itemSub.TOTAL_CNT) + ")"
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        0 < _vm.faqList.length
          ? _c("div", { staticClass: "faq_wrap" }, [
              _c(
                "ul",
                { staticClass: "faq_list" },
                _vm._l(_vm.faqList, function(item, idx) {
                  return _c(
                    "li",
                    {
                      key: _vm.pageName + item.FAQ_ID + idx,
                      class: item.GRADE === "S" ? "important" : ""
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ico_faq_q",
                          on: {
                            click: function($event) {
                              return _vm.faqClick($event, item.FAQ_ID)
                            }
                          }
                        },
                        [
                          "S" === item.GRADE
                            ? _c("em", { staticClass: "textcolor_important" }, [
                                _vm._v(
                                  "\n                            [" +
                                    _vm._s(_vm.$t("FIELD.GLOBAL.IMPORTANT")) +
                                    "]\n                        "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.TITLE) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "ico_faq_a" }, [
                        _c("div", { staticClass: "q_cont" }, [
                          _c("div", {
                            staticClass: "namo_scrollbar",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.stripHtml(item.QUESTION_DESC)
                              )
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "a_cont" },
                          [
                            _c("div", {
                              staticClass: "namo_scrollbar",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.stripHtml(item.SOLUTION_DESC)
                                )
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(item.attach.rowData, function(file) {
                              return _c(
                                "span",
                                {
                                  key: file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN
                                },
                                [
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "txt_link",
                                      attrs: {
                                        href: _vm.getDownloadUrl(
                                          file.ENC_ATTCH_FILE_SEQ,
                                          file.ENC_TOKEN
                                        ),
                                        download: "true",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(file.FILE_NM) +
                                          "\n                                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        "Y" === _vm.params.creationYn
                          ? _c("span", [
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "btn_wrap text_right pt-10" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "txt_link",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.register(item.FAQ_ID)
                                        }
                                      }
                                    },
                                    [_vm._v("Modify")]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn_wrap" }, [
                _vm.currentRecords < _vm.totalRecords
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_laodmore",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.search(0)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("BUTTON.SEARCH.LOAD.MORE")) +
                            "\n                    "
                        ),
                        _c("em", [
                          _vm._v("\n                        ("),
                          _c("i", [_vm._v(_vm._s(_vm.currentRecords))]),
                          _vm._v(
                            " / " +
                              _vm._s(_vm.totalRecords) +
                              ")\n                    "
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.viewYn ||
                  (0 === _vm.totalRecords && !_vm.viewYn && _vm.searchYn)) &&
                !_vm.getIsMobile
                  ? _c(
                      "a",
                      {
                        staticClass: "txt_link",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.register()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("MESSAGE.FAQ.CREATE")) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _c("div", { staticClass: "faq_wrap" }, [
              _c("ul", { staticClass: "faq_list" }, [
                _c("li", { staticClass: "nodata" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))])
                ])
              ])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "btn_ico_srchBtm", attrs: { href: "javascript:" } },
      [_c("span", { staticClass: "sr_only" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1afa5392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afa5392","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/viewFAQ.vue
// module id = us2y
// module chunks = 0